// Functions for matching/canonicalizing possible dates

// Hash mapping short month names to long ones...
export const MONTH_NAMES =
  'January,February,March,April,May,June,July,August,September,October,November,December';
export const MON = `{${MONTH_NAMES}}`.replace(/\b((\w\w\w)\w*)/g, function(
  m,
  val,
  key
) {
  return '"' + key.toLowerCase() + '":"' + val + '"';
});
export const MONTHS = JSON.parse(MON);

// Hash mapping short weekday names to long ones...
export const WKDAY_NAMES =
  'Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday';
export const WKD = `{${WKDAY_NAMES}}`.replace(/\b((\w\w\w)\w*)/g, function(
  m,
  val,
  key
) {
  return '"' + key.toLowerCase() + '":"' + val + '"';
});
export const WKDAYS = JSON.parse(WKD);

// Regex matching short month names
export const MONTH_REGEX = new RegExp(
  '\\b(?:' + Object.keys(MONTHS).join('|') + ')',
  'gi'
);

// Regex matching short weekday names
export const WDAYS_REGEX = new RegExp(
  '\\b(?:' + Object.keys(WKDAYS).join('|') + ')',
  'gi'
);
export const DAY_REGEX = /\b(?:\d{1,2}(?=\b|(?:(?:st|nd|rd|th)\b)))/g;
export const YEAR_REGEX = /\b(?:\d{4})\b/g;

export const FULL_MONTH_NAME_REGEX = new RegExp(
  '\\b(?:' + MONTH_NAMES.replace(/,/g, '|') + ')\\b'
);



// WEBPACK FOOTER //
// ./src/date_matching.js